import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

export const LineChart = ({ chart_list_date , chart_list_data }: any) => {

    const options = {
        responsive: true,
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                ticks: {
                    // forces step size to be 50 units
                    stepSize: 20,
                    offset: true
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
                text: 'Profit chart',
            },
        },
    };


    const labels = chart_list_date;

    const data = {
        labels,
        datasets: [
            {
                fill: true,
                label: 'میزان سود ($)',
                data: chart_list_data,
                borderColor: '#2563eb',
                backgroundColor: '#447aee',
                tension: 0.4,
            },
        ],
    };


    return (
        <>
            <Line style={{ width: "100%" }} options={options} data={data} height={145} />
        </>
    )
}